import { render, staticRenderFns } from "./InventoryViewUpdates.vue?vue&type=template&id=667b6ffc&"
import script from "./InventoryViewUpdates.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewUpdates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports